<template lang="pug">
.bg-white.pt-20
  .container
    #founders-letter.flex.flex-col.justify-between.items-center(class="md:flex-row")
      .text-gray-700.font-light(class="w-full md:w-5/12")
        div(v-html="computedFounderLetter")
        img(src="https://website-assets.atlan.com/img/founders-sign.webp" alt="founders sign" class="w-1/2")
        p.font-size-sm() (Co-founders of Atlan)
      .text-center(class="hidden w-full md:text-right md:w-6/12 md:block")
        img(src="https://website-assets.atlan.com/img/founders.webp" alt="founders" class="inline w-3/4")

    #job-description.pt-20
      .mb-20(v-html="job.description")
      //- .mb-20(v-for="(item, index) in job.lists.filter(x=>x.text !== 'redirect')" :key="index")
        h2.font-bold.mb-6.text-3xl {{item.text}}
        ul.columns-2.list-circle.text-gray-600(v-html="item.content")

  #quick-cta.bg-blue-500.px-4.py-20.text-center
    h1.text-white.text-4xl.mx-auto.font-semibold.mb-10() Can't wait to join us? <br/> Get started on your application.
    a.btn.btn-md.btn-pink-500(href="#application-form" class="px-10") Apply Now

  .container
    div(class="md:text-center")
      h1.mx-auto.text-4xl.font-bold.pt-20 Do your life's best work with Atlan
      
  //- .container
    pre.overflow-y-auto {{job}}
</template>

<script setup>
import { computed } from "vue";
import DefaultButton from "@components/common-blocks/buttons/DefaultButton.vue";

const props = defineProps({
  job: {
    type: Object,
    default: () => ({}),
  },
  formattedJob: {
    type: Object,
    default: () => ({}),
  },
});

const computedFounderLetter = computed(() => {
  if (props.formattedJob?.category === "product-and-engineering")
    return `<p class="mb-8">At Atlan, we are both proud and humbled by the fact that we are building products that power data teams in more than 50 countries around the world, ranging from small startups to Fortune 500 giants. Our products form the very backbone of our users, have become a part of their daily workflows and directly impact their success.</p><p class="mb-8">In the past decade, products like GitHub helped companies build great engineering cultures. At Atlan, we are on a quest to help build winning data teams of the future.</p><p class="mb-8"> Every line of code we write, every feature we add, every pixel we create—everything we do—is to help data teams around the world do their lives’ best work.</p><p class="mb-8">Let’s show the world how it’s done!</p>`;
  return `<p class="mb-8">At Atlan, one of our core values is putting the problem first and solution second. That’s why our folks in the Business Team come to work every morning with the intent of helping as many people as they can. Even if this means telling them that we’re not the right fit for them.</p><p class="mb-8">As part of our Business Team, you’ll be our eyes and ears on the ground—working to understand our users’ biggest challenges and wins—so we can integrate this information into our vision for our products. Every line of code we write and every pixel we create will be shaped by what you see and hear on a daily basis.</p><p class="mb-8">Let’s lead from the front and show the world how it’s done.</p>`;
});
</script>

<style lang="scss">
.list-circle li:before {
  background-color: #2026d2;
  border-radius: 50%;
  content: "";
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 2px;
  height: 7px;
  width: 7px;
}

.list-circle li {
  margin-bottom: 1.5rem;
  break-inside: avoid-column;
}

#quick-cta {
  background: url(https://website-assets.atlan.com/img/world-map.webp);
  background-color: #2026d2;
  background-size: unset;
  background-position: unset;
  background-repeat: no-repeat;
}

#job-description {
  h3 {
    font-size: 1.875rem;
    line-height: 2.25rem;
    font-weight: 700;
    margin-bottom: 1rem;
    margin-top: 2.5rem;
  }

  ul {
    margin-bottom: 2.5rem;

    @media only screen and (min-width: 768px) {
      column-count: 2;
    }

    li {
      margin-bottom: 1.5rem;
    }
    li:before {
      background-color: #2026d2;
      border-radius: 50%;
      content: "";
      display: inline-block;
      height: 7px;
      margin-bottom: 2px;
      margin-right: 10px;
      width: 7px;
    }
  }
}
</style>
